import * as React from 'react';
import { SpinnerOverlay } from '@weddingspot/ws-core-components';
import cn from 'classnames';

const styles = require('./ModalConfirm.scss');

interface OwnProps {
    header: string;
    content: string;
    primaryCta: string;
    secondaryCta?: string;

    primaryAsync: boolean;
    onPrimaryCtaClick: () => void | Promise<void>;

    secondaryAsync?: boolean;
    onSecondaryCtaClick?: () => void | Promise<void>;
}

interface OwnState {
    waiting: boolean;
}

export default class ConfirmModal extends React.Component<OwnProps, OwnState> {
    constructor(props: OwnProps) {
        super(props);

        this.hasSecondaryCta = this.hasSecondaryCta.bind(this);
        this.handleCtaClick = this.handleCtaClick.bind(this);
        this.handleSecondaryCtaClick = this.handleSecondaryCtaClick.bind(this);

        this.state = { waiting: false };
    }

    render() {
        return (
            <div>
                <div className={cn(styles.background, 'nx-modal-bg', 'nx-modal-bg--active')} />
                <div className={cn(styles.body, 'nx-modal', 'nx-modal--active')}>
                    <aside className='nx-modal__container'>
                        <div className={styles.container}>
                            <div className={styles.inner}>
                                <div className={styles.header}>{this.props.header}</div>
                                <div className={styles.text}>{this.props.content}</div>
                                <div className={styles.ctaContainer}>
                                    {this.hasSecondaryCta() && (
                                        <SpinnerOverlay isSpinning={this.state.waiting}>
                                            <button className={styles.secondaryCta} onClick={this.handleSecondaryCtaClick} type='button'>
                                                {this.props.secondaryCta}
                                            </button>
                                        </SpinnerOverlay>
                                    )}
                                    <SpinnerOverlay isSpinning={this.state.waiting}>
                                        <button
                                            className='nx-button nx-button--small nx-button--primary'
                                            onClick={this.handleCtaClick}
                                            type='button'
                                        >
                                            {this.props.primaryCta}
                                        </button>
                                    </SpinnerOverlay>
                                </div>
                            </div>
                        </div>
                    </aside>
                </div>
            </div>
        );
    }

    private setWaiting() {
        this.setState({ waiting: true });
    }

    private setDone() {
        this.setState({ waiting: false });
    }

    private hasSecondaryCta() {
        return !!this.props.secondaryCta && !!this.props.onSecondaryCtaClick;
    }

    private handleCtaClick() {
        if (this.props.primaryAsync) {
            this.setWaiting();
            (this.props.onPrimaryCtaClick() as Promise<void>).then(() => this.setDone());
        } else {
            this.props.onPrimaryCtaClick();
        }
    }

    private handleSecondaryCtaClick() {
        if (!this.props.onSecondaryCtaClick) {
            return;
        }

        if (this.props.secondaryAsync) {
            this.setWaiting();
            (this.props.onSecondaryCtaClick() as Promise<void>).then(() => this.setDone());
        } else {
            this.props.onSecondaryCtaClick();
        }
    }
}
